import { gql } from "@apollo/client";

export const GET_VALIDAR_INSUMO_FOR_EXPORT = gql`
query GetAllValidarInsumoExport(
    $where: t_InsumoFilterInput  
    $order : [t_InsumoSortInput!] 
) {
    allValidarInsumoForExport(where: $where, order: $order )
    {
        idInsumoN,
        idInsumo,
        descripcion,
        descripcionGenerica,
        validado,
        activo
    }
}`;